var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper",attrs:{"id":"content-wrap"}},[_c('section',{staticClass:"content clearfix"},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }